export const API_KEY = "AIzaSyDnmzohTtNgsA-_mHob0bMCXeD1lJ0bzpo";

export default API_KEY;